function applyGliderProva() {
  const sliderElement = document.querySelector(".gliderProva");
  if (!sliderElement || typeof Glider === "undefined" || sliderElement._glider) return;

  new Glider(sliderElement, {
    slidesToShow: 3,
    dots: ".dots",
    draggable: false,
    scrollLock: false,
    arrows: {
      prev: ".glider-prev-prova",
      next: ".glider-next-prova"
    },
    responsive: [
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          duration: 0.25
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          itemWidth: 150,
          duration: 0.25
        }
      }
    ]
  });
}

applyGliderProva();
document.addEventListener("shopify:section:load", applyGliderProva);
